import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import Loader from 'components/Loader';

const DashboardContainer = ({
  children,
  header,
  subheader,
  rightContent,
  fullPageLoading,
  transitionIn,
  transitionAppear,
  className,
}) => {
  const nodeRef = useRef(null);

  return (
    <CSSTransition
      classNames="transitionGroup"
      in={transitionIn}
      appear={transitionAppear}
      timeout={300}
      nodeRef={nodeRef}
    >
      {fullPageLoading ? (
        <Loader />
      ) : (
        <div className="flex flex-col items-start mt-12" ref={nodeRef}>
          <div className="flex flex-col lg:flex-row w-full mb-7">
            <div className="flex-auto">
              <h1 className="text-javelin-gray-dark font-bold text-xl lg:text-8">
                {header}
              </h1>
              <h2 className="text-sm lg:text-base lg:leading-5 text-left text-javelin-gray-light pt-3">
                {subheader}
              </h2>
            </div>
            {rightContent}
          </div>
          {children}
        </div>
      )}
    </CSSTransition>
  );
};

DashboardContainer.propTypes = {
  children: PropTypes.node,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  subheader: PropTypes.string,
  rightContent: PropTypes.node,
  transitionIn: PropTypes.bool,
  transitionAppear: PropTypes.bool,
  fullPageLoading: PropTypes.bool,
};
DashboardContainer.defaultProps = {
  rightContent: null,
  transitionIn: true,
  transitionAppear: true,
  fullPageLoading: false,
};

export default memo(DashboardContainer);
